import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import BottomSheet from "@/components/shared/mobile/BottomSheet.tsx";
import { map } from "lodash";
import { useBottomSheet } from "@/components/shared/hooks/mobile/useBottomSheet.tsx";
import { removeSearchParams } from "@/helpers/tixxt-router.tsx";
import classNames from "classnames";

type TabSelectArgs = {
  tabs: {
    label: string;
    required?: boolean;
    error?: Error;
    url?: string;
  }[];
  className?: string;
  selectTabIndex: (val: number) => void;
  selectedTabIndex: number;
  // Shown when selectedTabIndex points to no tab (e.g. -1).
  placeholder?: string;
};

export default function TabSelect({
  tabs,
  selectTabIndex,
  selectedTabIndex,
  className,
  placeholder = I18n.t("js.tab_select.no_selection"),
}: TabSelectArgs) {
  const { showSheet, isAnimating, toggleSheet, closeSheet } = useBottomSheet();

  return (
    <>
      <div className={className}>
        <button
          type="button"
          className="stack-container btn btn-light h-11 w-full items-center"
          onClick={toggleSheet}
        >
          <span className="stack-item text-lg font-semibold">
            {tabs[selectedTabIndex]?.label ?? placeholder}
          </span>
          <FontAwesomeIcon
            className="stack-item justify-self-end"
            icon={faChevronDown}
            size="xl"
          />
        </button>
      </div>
      <BottomSheet
        showSheet={showSheet}
        onClose={closeSheet}
        isAnimating={isAnimating}
      >
        <ul className="divide-y divide-neutral/25">
          {map(tabs, (tab, index) => (
            <li
              className={classNames({
                "bg-primary/25": index === selectedTabIndex,
              })}
            >
              <a
                href={tab.url || "#"}
                onClick={(e) => {
                  // Tabs without a real url (e.g. the in-page profile tabs)
                  // fall back to href="#", whose default navigation would push
                  // a new screen in the app instead of switching the tab pane.
                  if (!tab.url) e.preventDefault();
                  selectTabIndex(index);
                  removeSearchParams();
                  closeSheet();
                }}
                className="flex w-full text-lg items-center justify-center h-11 text-normal focus:underline-none"
              >
                {tab.label}
              </a>
            </li>
          ))}
        </ul>
      </BottomSheet>
    </>
  );
}
